export default __webpack_public_path__ + "static/media/OASIS.d683b99a.svg";